/* eslint-disable react/jsx-no-target-blank */
import React, { Component } from 'react';
import { shadeColor } from '../../../utils/hexToRgb';
import { customGaEvent, GA_EVENTS } from '../../../utils/ga';

class LinkHover extends Component {
  constructor() {
    super();
    this.state = {
      hovering: false,
    };
  }

  handleHover = () => {
    this.setState(state => ({ hovering: !state.hovering }));
  };

  handleLinkStyles = () => {
    const { hovering } = this.state;
    const { normal = {}, hover = {}, show } = this.props;
    const isMobile = window.innerWidth < 1024;
    if (show && !isMobile) {
      return {
        backgroundColor: shadeColor(hover.background, 10),
        color: hover.text,
      };
    }

    return {
      backgroundColor: hovering ? hover.background : normal.background,
      color: hovering ? hover.text : normal.text,
    };
  };

  linkOnClickEvent = title => {
    customGaEvent({
      action: GA_EVENTS.BUTTON_CLICK,
      label: title,
    });
    return true;
  };

  render() {
    const { hovering } = this.state;
    const {
      title,
      url,
      newTab,
      className,
      index,
      hover,
      isMobile,
    } = this.props;
    const showIcon = index === 0 && !isMobile;
    return (
      <a
        className={className}
        href={url}
        target={newTab ? '_blank' : null}
        rel={newTab ? 'noopener noreferrer' : null}
        style={this.handleLinkStyles()}
        onMouseEnter={this.handleHover}
        onMouseLeave={this.handleHover}
        onClick={() => this.linkOnClickEvent(title)}
      >
        {showIcon && (
          <i
            className="material-icons"
            aria-hidden="true"
            style={{ color: hovering ? hover.background : hover.text }}
          >
            arrow_drop_up
          </i>
        )}
        {title}
      </a>
    );
  }
}

export default LinkHover;
